import React, { Fragment, Suspense, useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axios from "axios";
import { base_url } from "./Constants";
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const ServiceDetailsInner = React.lazy(() =>
  import("../components/ServiceDetailsInner")
);
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const ServiceDetails = () => {
  const {t,i18n} = useTranslation();
  const {lang,id}  =  useParams();
  const [data,setData] = useState(null);
  useEffect(()=>{
       axios.get(base_url+'/api/single-service/'+id,{
        headers:{
          language:lang
        }
       }).then(response=>{
          setData(response.data.data);
       })
        },[]);
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />
          {data&&(<>
                  <NavbarOne og_title={data.name} og_text={data.meta_text}
                    og_image={base_url+'/'+data.header_bg} />
                  <Breadcrumb title={data.name} header_bg={base_url+'/'+data.header_bg} />
                  <ServiceDetailsInner data={data} />
                  <FooterOne />
                  <FooterBottomOne />
          </>)}
          
        </Suspense>{" "}
      </Fragment>
    </>
  );
};

export default ServiceDetails;
